try {
  function sendAction(payload) {
    window.top.postMessage(JSON.stringify(payload), '*');
  }
  function initLoginWithEmailFunction() {
    try {
      const form = document.querySelector('form[data-gevme-form="gevme-form"]');
      const loginWithGoogle = document.querySelector('.loginWithGoogle');
      const loginForm = document.querySelector('div[data-gevme-form="gevme-login"]');
      const email = document.querySelector('input[data-gevme-input="gevme-email"]');
      const submitForm = document.querySelector('input[data-gevme-input="gevme-submit"]');
      const generalError = document.querySelector('p[data-error="general"]');
      const emailError = document.querySelector(`p[data-error="email"]`);
      const otpForm = document.querySelector('div[data-gevme-form="gevme-otp"]');
      const otpError = document.querySelector(`p[data-error="otp"]`);
      const otpBack = document.querySelector('a[data-gevme-anchor="gevme-back"]');
      if (loginWithGoogle) {
        loginWithGoogle.addEventListener('click', function (event) {
          event.preventDefault();
          sendAction({ type: 'loginwithgoogle' });
        });
      }
      if (otpBack) {
        otpBack.addEventListener('click', function (event) {
          event.preventDefault();
          otpForm.style.display = 'none';
          loginForm.style.display = 'flex';
          email.classList.remove('input-error', 'email-error');
          submitForm.removeAttribute('disabled');
          submitForm.value = 'Check In';
        });
      }
      if (email) {
        email.addEventListener('input', function () {
          email.classList.remove('input-error', 'email-error');
          emailError.textContent = '';
        });
      }
      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          const data = new FormData(form);
          let payload = { type: 'loginWithEmail' };
          for (const [name, value] of data) {
            payload = { ...payload, [name]: value };
          }
          if (!validateEmail(payload.email)) {
            email.classList.add('input-error', 'email-error');
            return (emailError.textContent = 'Please enter the correct email format.');
          }
          generalError.textContent = '';
          form.classList.add('form-submitted', 'form-loading');
          email.classList.remove('input-error', 'email-error');
          submitForm.setAttribute('disabled', true);
          submitForm.value = 'Checking in...';
          return sendAction(payload);
        })
      }
      function validateEmail(email) {
        return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(email);
      }
      function renderOTPInput(payload) {
        try {
          const pHead = otpForm.querySelector('p[data-gevme-p="gevme-p"]');
          const otpWrap = document.querySelector('#otp-wrap');
          otpWrap.innerHTML = '';
          for (let inputNum = 0; inputNum < parseInt(otpWrap.dataset.otpLength); inputNum++) {
            const createdInput = document.createElement('input');
            createdInput.type = 'number';
            createdInput.id = `input-${inputNum}`;
            createdInput.maxLength = 1;
            otpWrap.append(createdInput);
          }
          const inputs = document.querySelectorAll('#otp-wrap > *[id]');
          let num = {};
          form.parentElement.style.display = 'none';
          otpForm.style.display = 'flex';
          otpError.textContent = payload.type === 'error' ? payload?.data?.message : '';
          pHead.textContent = payload?.message || '';
          for (let i = 0; i < inputs.length; i++) {
            inputs[i].value = '';
            inputs[i].addEventListener('keydown', function keyEvent(event) {
              otpError.textContent = '';
              if (event.key === 'Backspace') {
                inputs[i].value = '';
                if (i !== 0) {
                  inputs[i - 1].focus();
                }
              } else {
                if (!/[0-9]|\./.test(event.key)) {
                  event.preventDefault();
                  return false;
                }
                if (i === inputs.length - 1 && inputs[i].value !== '') {
                  return true;
                } else if ((event.keyCode > 47 && event.keyCode < 58) || (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || (event.keyCode === 229 && event.key === 'Unidentified')) {
                  inputs[i].value = event.key;
                  if (i !== inputs.length - 1) {
                    inputs[i + 1].focus();
                  }
                  event.preventDefault();
                } else if ((event.keyCode > 64 && event.keyCode < 91) || (event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || (event.keyCode === 229 && event.key === 'Unidentified')) {
                  inputs[i].value = String.fromCharCode(event.keyCode);
                  if (i !== inputs.length - 1) {
                    inputs[i + 1].focus();
                  }
                  event.preventDefault();
                }
              }
              num[`${i}`] = inputs[i].value;
              if (Object.keys(num).length > 3 && Object.values(num).every((x) => x !== null && x !== '')) {
                let otp = '';
                Object.values(num).map((e) => (otp = `${otp}` + `${e}`));
                otpForm.classList.add('form-submitted', 'form-loading');
                num = {};
                inputs[0].focus();
                return sendAction({ ...payload, code: otp, type: 'otp' });
              }
            });
          }
        } catch (error) {
          console.error(error);
        }
      }
      function handleResponseFromPlatform(event) {
        try {
          const payload = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
          form.classList.remove('form-submitted', 'form-loading');
          if (payload) {
            if (payload.type === 'error') {
              if (payload.data.errorType === 'email') {
                email.classList.add('input-error', 'email-error');
                submitForm.removeAttribute('disabled');
                submitForm.value = 'Check In';
                emailError.textContent = payload?.data?.message || 'Something went wrong. Please try again.';
              }
              if (payload.data.errorType === 'otp') {
                otpError.textContent = payload?.data?.message || 'Something went wrong. Please try again.';
              }
              if (payload.data.errorType === 'google') {
                loginWithGoogle.classList.add('error');
                generalError.textContent = payload?.data?.message || 'Something went wrong. Please try again.';
              }
            }
            if (payload.type === 'login') {
              if (!payload.status) {
                submitForm.removeAttribute('disabled');
                submitForm.value = 'Check In';
                return (generalError.textContent = payload?.message);
              }
              return typeof window.renderOTPInput !== 'undefined' ? window.renderOTPInput(payload) : renderOTPInput(payload);
            }
          }
        } catch (error) {
          console.error(error.message)
          generalError.textContent = error.message
        }
      }
      window.addEventListener('message', handleResponseFromPlatform);
    } catch (error) {
      console.error(error)
    }
  }
  function initLoginWithUsernamePwdFunction() {
    try {
      const form = document.querySelector('form[data-gevme-form="gevme-form"]');
      const username = document.querySelector('input[data-gevme-input="gevme-username"]');
      const password = document.querySelector('input[data-gevme-input="gevme-password"]');
      const submitForm = document.querySelector('input[data-gevme-input="gevme-submit"]');
      const usernameError = document.querySelector(`p[data-error="username"]`);
      const passwordError = document.querySelector(`p[data-error="password"]`);
      const generalError = document.querySelector('p[data-error="auth0"]');
      if (username) {
        username.addEventListener('input', function () {
          username.classList.remove('input-error', 'username-error');
          usernameError.textContent = '';
          generalError.textContent = '';
          generalError.style.margin = '0px';
        });
      }
      if (password) {
        password.addEventListener('input', function () {
          password.classList.remove('input-error', 'password-error');
          passwordError.textContent = '';
          generalError.textContent = '';
          generalError.style.margin = '0px';
        })
      }
      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          const data = new FormData(form);
          let payload = { type: 'loginWithUsernamePwd' };
          for (const [name, value] of data) {
            payload = { ...payload, [name]: value };
          }
          if (!payload.username) {
            username.classList.add('input-error', 'username-error');
            return (usernameError.textContent = 'Please enter the username.');
          }
          if (!payload.password) {
            password.classList.add('input-error', 'password-error');
            return (passwordError.textContent = 'Please enter the password.');
          }
          generalError.textContent = '';
          generalError.style.margin = '0px';
          form.classList.add('form-submitted', 'form-loading');
          submitForm.setAttribute('disabled', true);
          submitForm.value = 'Checking in...';
          return sendAction(payload);
        });
      }
      function handleResponseFromPlatform(event) {
        try {
          const payload = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
          form.classList.remove('form-submitted', 'form-loading');
          if (payload) {
            if (payload.type === 'error') {
              if (payload.data.errorType === 'username') {
                username.classList.add('input-error', 'username-error');
                usernameError.textContent = payload?.data?.message || 'Something went wrong. Please try again.';
              }
              if (payload.data.errorType === 'password') {
                password.classList.add('input-error', 'password-error');
                passwordError.textContent = payload?.data?.message || 'Something went wrong. Please try again.';
              }
              if (payload.data.errorType === 'auth0') {
                password.classList.add('input-error', 'password-error');
                username.classList.add('input-error', 'username-error');
                generalError.style.margin = '0px 0px 15px 0px';
                generalError.textContent = payload?.data?.message || 'Something went wrong. Please try again.';
              }
              submitForm.removeAttribute('disabled');
              submitForm.value = 'Check In';
            }
          }
        } catch (error) {
          console.error(error.message);
          generalError.textContent = error.message;
          generalError.style.margin = '0px 0px 20px 0px';
          submitForm.removeAttribute('disabled');
          submitForm.value = 'Check In';
        }
      }
      window.addEventListener('message', handleResponseFromPlatform);
    } catch (error) {
      console.error(error);
    }
  }
  function initLoginWithSharedPasswordFunction() {
    try {
      const form = document.querySelector('form[data-gevme-form="gevme-form"]');
      const inputs = document.querySelectorAll('input[data-gevme-input]');
      const submitForm = document.querySelector('input[data-gevme-input="gevme-submit"]');
      const generalError = document.querySelector('p[data-error="general"]');
      if (inputs?.length > 0) {
        inputs.forEach((input) => {
          input.addEventListener('input', function () {
            input.classList.remove('input-error');
            generalError.textContent = '';
          });
        });
      }
      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          const data = new FormData(form);
          let payload = { type: 'loginWithSharedPwd' };
          for (const [name, value] of data) {
            payload = { ...payload, [name]: value };
          }
          generalError.textContent = '';
          form.classList.add('form-submitted', 'form-loading');
          submitForm.setAttribute('disabled', true);
          submitForm.value = 'Checking in...';
          return sendAction(payload);
        });
      }
      function handleResponseFromPlatform(event) {
        try {
          const payload = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
          form.classList.remove('form-submitted', 'form-loading');
          if (payload) {
            if (payload.type === 'error') {
              submitForm.removeAttribute('disabled');
              submitForm.value = 'Check In';
              generalError.textContent = payload?.data?.message || 'Something went wrong. Please try again.';
            }
            if (payload.type === 'login') {
              if (!payload.status) {
                submitForm.removeAttribute('disabled');
                submitForm.value = 'Check In';
                return (generalError.textContent = payload?.message);
              }
              if (form.parentElement) {
                form.parentElement.style.display = 'none';
                const pHead = otpForm.querySelector('p[data-gevme-p="gevme-p"]');
                pHead.textContent = payload.message;
                return sendAction(payload);
              }
            }
          }
        } catch (error) {
          console.error(error.message);
          generalError.textContent = error.message;
        }
      }
      window.addEventListener('message', handleResponseFromPlatform);
    } catch (error) {
      console.error(error);
    }
  }
  window.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('form[data-gevme-form="gevme-form"]');
    if (form) {
      switch (form.getAttribute('data-gevme-login-type').toLocaleLowerCase()) {
        case 'login-with-email': {
          initLoginWithEmailFunction();
          break;
        }
        case 'login-with-username-pwd': {
          initLoginWithUsernamePwdFunction();
          break;
        }
        case 'login-with-shared-pwd': {
          initLoginWithSharedPasswordFunction();
          break;
        }
      }
    }
  });
} catch (error) {
  console.error(error.message);
}
